/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable no-else-return */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
import React, { useState, useRef, useEffect } from 'react';
import { Col, Overlay, Row } from 'react-bootstrap';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  formatDate,
  getNewDate,
  getTime24Hour,
  isMobileWidth,
  parseTimeString,
  serialize,
} from '../../../shared/helper-utils/appUtils';
import { debounce } from 'lodash';
import { getCitiesApiV2, getLatLngApiV2 } from '../../../api/hotelApi';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import { add } from 'date-fns';
import AppTimePicker from '../../../shared/components/app-time-picker/AppTimePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import '../../landing/LandingPage.scss';
import { useNavigate } from 'react-router-dom';
import { searchCabsCitiesApi } from '../../../api/cabApi';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import './CabsSearch.scss';
import PropTypes from 'prop-types';

export function locationOptions(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'location-focused' : ''} location-option`}
      key={props.value}
    >
      <div className="d-flex">
        {/* <span
          className={`${isMobileWidth() ? 'fs-14' : 'fs-16'}`}
        >{`${props.data.label},${props.data.country}`}</span> */}
        <span
          className={`${isMobileWidth() ? 'fs-14' : 'fs-16'}`}
        >{`${props.data.label}`}</span>
      </div>
    </div>
  );
}

function CabsSearch({ previousSearchRequest, isModifySearch }) {
  const DEBOUNCE_DELAY = 2000;
  const intl = useIntl();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState({
    tripType: 'oneway',
    pickup: {
      lat: 51.47002,
      lng: -0.454295,
      address: '',
      placeId: '',
      terminal: '',
      placeType: '',
      countryName: '',
    },
    dorpup: {
      lat: 51.523767,
      lng: -0.1585557,
      address: '',
      placeId: '',
      terminal: '',
      placeType: '',
      countryName: '',
    },
    onwordDetails: {
      journeyDate: getNewDate(TODAY_DATE),
      journeyTime: '11:00',
    },
    returnDetails: {
      journeyDate: '',
      journeyTime: '',
    },
    adults: 1,
    childs: 0,
    infants: 0,
    childAges: [],
    filters: [
      {
        filterName: '',
        filterVale: '',
      },
    ],
  });
  const pickupRef = useRef(null);
  const dropupRef = useRef(null);
  const pickupTimeRef = useRef(new Date());
  const passengersOverlayTarget = useRef(null);
  const [openPassengers, setOpenPassengers] = useState(false);
  const isMobileView = useRef(false);
  const NUMPAX_DICT = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const [searchType, setSearchType] = useState('IATA');
  const searchTypes = [
    { label: 'IATA', value: 'IATA' },
    { label: 'TRAIN', value: 'TRAIN' },
    { label: 'PORT', value: 'PORT' },
    { label: 'ATLAS', value: 'ATLAS' },
  ];
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const getLabel = (city) => {
    return (
      <div className={`${isMobileWidth() ? 'fs-14 fw-600' : 'fs-5 fw-600'}`}>
        {city}
      </div>
    );
  };

  const loadLocationSuggestions = debounce(async (query, callback) => {
    let cities = [];

    if (query.length >= 3) {
      const response = await searchCabsCitiesApi(
        encodeURIComponent(query),
        searchType,
      );
      if (response) {
        cities = response.map((node) => ({
          code: node.code,
          countryName: node.countryName,
          label: `${node.code} - ${node.name}, ${node.countryName}`,
          type: node.type,
        }));
      } else {
        cities = [{ label: 'No Value Found', value: 0 }];
      }
    } else {
      // Always send at least 1 option if you want locationOptions to render
      cities = [{ label: 'Type 3 or more characters...', value: 0 }];
    }

    callback(cities);
  }, DEBOUNCE_DELAY);

  const handleUpdateSearchState = (name, value) => {
    setSearch((prevState) => {
      if (name === 'onwordDetails.journeyDate') {
        return {
          ...prevState,
          onwordDetails: {
            ...prevState.onwordDetails,
            journeyDate: value,
          },
        };
      } else if (name === 'onwordDetails.journeyTime') {
        return {
          ...prevState,
          onwordDetails: {
            ...prevState.onwordDetails,
            journeyTime: value,
          },
        };
      } else {
        return {
          ...prevState,
          [name]: value,
        };
      }
    });
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };
  const handleLocationSelect = async (city, name) => {
    let country = '';
    if (city !== null) {
      country = city.country;
    }
    let searchtype = searchType;
    if (searchType === 'TRAIN') {
      searchtype = 'STATION';
    }
    if (name === 'pickup') {
      pickupRef.current = city;
      handleUpdateSearchState('pickup', {
        placeType: searchtype,
        countryName: city.countryName,
        placeId: city.code,
      });
      const currentIndex = searchTypes.findIndex((i) => i.value === searchType);
      const dropType =
        currentIndex !== -1 && currentIndex < searchTypes.length - 1
          ? searchTypes[currentIndex + 1].value
          : searchTypes[0].value;
      setSearchType(dropType);
    } else {
      dropupRef.current = city;
      handleUpdateSearchState('dorpup', {
        placeType: searchtype,
        countryName: city.countryName,
        placeId: city.code,
      });
    }
  };
  const handleDateChange = (date, fieldName) => {
    handleUpdateSearchState(fieldName, date);
  };

  const handleChildAgeChange = (childIndex, value) => {
    setSearch((prevState) => {
      const updatedAges = [...prevState.childAges];
      updatedAges[childIndex] = value;
      return {
        ...prevState,
        childAges: updatedAges,
      };
    });
  };

  const handleCabSearch = () => {
    const errorsObj = {};
    if (search.pickup === '') {
      errorsObj.pickup = formattedMessage('pickup_validation');
    }
    if (search.dorpup === '') {
      errorsObj.drop = formattedMessage('dropup_validation');
    }
    if (search.onwordDetails.journeyTime === '') {
      errorsObj.journeyTime = formattedMessage('pickup_time_validation');
    }
    setErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0) {
      return true;
    }
    const searchRequest = {
      ...search,
      onwordDetails: {
        ...search.onwordDetails,
        journeyDate: formatDate(
          search.onwordDetails.journeyDate,
          API_DATE_FORMAT,
        ),
      },
    };
    const queryParam = serialize(searchRequest);
    navigate(`${NAVIGATION_ROUTES.CABS.CABS_SEARCH}?${queryParam}`);
  };

  useEffect(() => {
    if (previousSearchRequest) {
      setSearch((prev) => ({
        ...prev,
        adults: previousSearchRequest.adults,
        childAges: previousSearchRequest.childAges,
        childs: previousSearchRequest.childs,
        onwordDetails: {
          ...prev.onwordDetails,
          journeyDate: getNewDate(
            previousSearchRequest?.onwordDetails?.journeyDate,
          ),
          journeyTime: previousSearchRequest?.onwordDetails?.journeyTime,
        },
        pickup: {
          ...prev.pickup,
          lat: previousSearchRequest?.pickup?.lat,
          lng: previousSearchRequest?.pickup?.lng,
          address: previousSearchRequest?.pickup?.address,
          placeId: previousSearchRequest?.pickup?.placeId,
          terminal: previousSearchRequest?.pickup?.terminal,
          placeType: previousSearchRequest?.pickup?.placeType,
          countryName: previousSearchRequest?.pickup?.countryName,
        },
        dorpup: {
          ...prev.dorpup,
          lat: previousSearchRequest?.dorpup?.lat,
          lng: previousSearchRequest?.dorpup?.lng,
          address: previousSearchRequest?.dorpup?.address,
          placeId: previousSearchRequest?.dorpup?.placeId,
          terminal: previousSearchRequest?.dorpup?.terminal,
          placeType: previousSearchRequest?.dorpup?.placeType,
          countryName: previousSearchRequest?.dorpup?.countryName,
        },
      }));
      pickupRef.current = {
        label: `${previousSearchRequest?.pickup.placeId} - ${previousSearchRequest?.pickup.countryName}`,
        value: previousSearchRequest?.pickup.placeId,
      };
      dropupRef.current = {
        label: `${previousSearchRequest?.dorpup.placeId} - ${previousSearchRequest?.dorpup.countryName}`,
        value: previousSearchRequest?.dorpup.placeId,
      };
    }
  }, [previousSearchRequest]);
  return (
    <div className="cab-search-container">
      {!isModifySearch ? (
        <>
          <div className="d-flex gap-4 mb-3">
            {searchTypes.map((type) => (
              <div key={type.value}>
                <AppRadioInput
                  id={type.value}
                  name="searchType"
                  value={type.value}
                  checked={searchType === type.value}
                  onChange={() => setSearchType(type.value)}
                  labelText={type.label}
                />
              </div>
            ))}
          </div>
          <div>
            <Row>
              <Col lg={3} md={3} sm={3} xs={12}>
                <AppAsyncSelect
                  name="pickup"
                  placeholder="Select Pickup"
                  label={formattedMessage('from')}
                  menuWidth="320px !important"
                  height={isMobileWidth() ? '54px' : undefined}
                  padding={isMobileWidth() ? '8px 14px' : undefined}
                  components={{ Option: locationOptions }}
                  loadOptionsFn={loadLocationSuggestions}
                  onSelect={handleLocationSelect}
                  selectedValue={pickupRef.current}
                  selectedTab="cabs"
                />
                <small className="validation-error">{errors.pickup}</small>
              </Col>
              <Col lg={3} md={3} sm={3} xs={12}>
                <AppAsyncSelect
                  name="dorpup"
                  label={formattedMessage('to')}
                  placeholder="Select Drop"
                  menuWidth="320px !important"
                  height={isMobileWidth() ? '54px' : undefined}
                  padding={isMobileWidth() ? '8px 14px' : undefined}
                  components={{ Option: locationOptions }}
                  loadOptionsFn={loadLocationSuggestions}
                  onSelect={handleLocationSelect}
                  selectedValue={dropupRef.current}
                  selectedTab="cabs"
                />
                <small className="validation-error">{errors.drop}</small>
              </Col>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppDatePicker
                  name="onwordDetails"
                  label={formattedMessage('journey_date')}
                  placeholder={formattedMessage('journey_date')}
                  dateFormat="dd MMM yy"
                  customClassName="app-landing-datepicker"
                  labelClassName="landing-datepicker-label"
                  minDate={getNewDate(TODAY_DATE)}
                  monthsShown={2}
                  selectedDate={search.onwordDetails.journeyDate}
                  onChange={(date) =>
                    handleDateChange(date, 'onwordDetails.journeyDate')
                  }
                  showDay
                />
                <small className="validation-error">{errors.journeyDate}</small>
              </Col>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppTimePicker
                  name="onwordDetails"
                  label={formattedMessage('pickup_time')}
                  placeholder={formattedMessage('pickup_time')}
                  customClassName="app-landing-datepicker"
                  labelClassName="landing-datepicker-label"
                  selectedTime={pickupTimeRef.current}
                  onChange={(e) => {
                    pickupTimeRef.current = e;
                    handleUpdateSearchState(
                      'onwordDetails.journeyTime',
                      getTime24Hour(e),
                    );
                  }}
                />
                <small className="validation-error">{errors.journeyTime}</small>
              </Col>
              <Col lg={2} md={2} sm={12} xs={12}>
                <div
                  className="travellers-class d-flex justify-content-between align-items-center cursor-pointer"
                  ref={passengersOverlayTarget}
                  onClick={() => setOpenPassengers(!openPassengers)}
                >
                  <div className="d-flex flex-column">
                    <span className="fs-12 travellers-class_label">
                      <FormattedMessage id="travellers" />,{' '}
                      <FormattedMessage id="class" />
                    </span>
                    <span className="travellers-class_text">
                      {parseInt(search.adults, 10)}A,
                      {search.childs > 0 && `${parseInt(search.childs, 10)}C,`}
                      {search.infants > 0 &&
                        `${parseInt(search.infants, 10)}I,`}
                    </span>
                  </div>
                  {openPassengers ? (
                    <MdKeyboardArrowUp />
                  ) : (
                    <MdKeyboardArrowDown />
                  )}
                </div>
                <Overlay
                  rootClose
                  target={passengersOverlayTarget.current}
                  show={openPassengers}
                  placement="bottom"
                  onHide={() => setOpenPassengers(false)}
                >
                  {({
                    placement,
                    arrowProps,
                    show: _show,
                    popper,
                    ...props
                  }) => (
                    <div
                      {...props}
                      style={{
                        position: 'absolute',
                        padding: '1rem',
                        borderRadius: '8px',
                        maxWidth: isMobileView.current ? '92%' : '320px',
                        backgroundColor: '#b0d3f6',
                        zIndex: 9999,
                        ...props.style,
                      }}
                      className="travellers-class_overlay"
                    >
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="adults12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map(
                              (pax) =>
                                pax !== '0' && (
                                  <li
                                    key={pax}
                                    className={`${
                                      search.adults === pax ? 'selected' : ''
                                    } num-pax_list_item`}
                                    onClick={() =>
                                      handleUpdateSearchState('adults', pax)
                                    }
                                  >
                                    {pax}
                                  </li>
                                ),
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="children_2_12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.childs === pax ? 'selected' : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('childs', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="d-flex gap-3 flex-wrap">
                          {search.childs > 0 &&
                            Array.from({
                              length: parseInt(search.childs, 10),
                            }).map((_, indexOfChild) => (
                              <div key={indexOfChild}>
                                <div className="my-1 d-flex gap-1 fs-12 flex-column align-items-center">
                                  <label
                                    htmlFor={`child${indexOfChild}`}
                                    className="fw-500"
                                  >
                                    {formattedMessage('child')}{' '}
                                    {indexOfChild + 1} {formattedMessage('age')}
                                    *
                                  </label>
                                  <select
                                    name={`child${indexOfChild}`}
                                    value={search.childAges[indexOfChild]}
                                    onChange={(e) =>
                                      handleChildAgeChange(
                                        indexOfChild,
                                        e.target.value,
                                      )
                                    }
                                    style={{
                                      width: 'fit-content',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                  </select>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="infant_2" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.infants === pax ? 'selected' : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('infants', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="text-center">
                        <AppButton
                          btnText={<FormattedMessage id="done_btn" />}
                          onClick={() => setOpenPassengers(false)}
                          variant="secondary"
                          className="px-4"
                        />
                      </div>
                    </div>
                  )}
                </Overlay>
              </Col>
            </Row>
            <div className="d-flex justify-content-center service-search-btn">
              <AppButton
                btnText="Search Cabs"
                variant="primary"
                onClick={handleCabSearch}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="cab-modify-search">
          <div className="d-flex gap-4 mb-3">
            {searchTypes.map((type) => (
              <div key={type.value}>
                <AppRadioInput
                  id={type.value}
                  name="searchType"
                  value={type.value}
                  checked={searchType === type.value}
                  onChange={() => setSearchType(type.value)}
                  labelText={type.label}
                />
              </div>
            ))}
          </div>
          <div>
            <Row>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppAsyncSelect
                  name="pickup"
                  placeholder="Select Pickup"
                  label={formattedMessage('from')}
                  menuWidth="320px !important"
                  height="54px"
                  padding="8px 14px"
                  components={{ Option: locationOptions }}
                  loadOptionsFn={loadLocationSuggestions}
                  onSelect={handleLocationSelect}
                  selectedValue={pickupRef.current}
                  selectedTab="cabs"
                />
                <small className="validation-error">{errors.pickup}</small>
              </Col>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppAsyncSelect
                  name="dorpup"
                  label={formattedMessage('to')}
                  placeholder="Select Drop"
                  menuWidth="320px !important"
                  height="54px"
                  padding="8px 14px"
                  components={{ Option: locationOptions }}
                  loadOptionsFn={loadLocationSuggestions}
                  onSelect={handleLocationSelect}
                  selectedValue={dropupRef.current}
                  selectedTab="cabs"
                />
                <small className="validation-error">{errors.drop}</small>
              </Col>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppDatePicker
                  name="onwordDetails"
                  label={formattedMessage('journey_date')}
                  placeholder={formattedMessage('journey_date')}
                  dateFormat="dd MMM yy"
                  customClassName="cabs-modify-datepicker"
                  labelClassName="cabs-modify-datepicker-label"
                  minDate={getNewDate(TODAY_DATE)}
                  monthsShown={2}
                  selectedDate={search.onwordDetails.journeyDate}
                  onChange={(date) =>
                    handleDateChange(date, 'onwordDetails.journeyDate')
                  }
                  // showDay
                />
                <small className="validation-error">{errors.journeyDate}</small>
              </Col>
              <Col lg={2} md={2} sm={2} xs={12}>
                <AppTimePicker
                  name="onwordDetails"
                  label={formattedMessage('pickup_time')}
                  placeholder={formattedMessage('pickup_time')}
                  customClassName="cabs-modify-datepicker"
                  labelClassName="cabs-modify-datepicker-label"
                  // selectedTime={pickupTimeRef.current}
                  selectedTime={parseTimeString(
                    search.onwordDetails.journeyTime,
                  )}
                  onChange={(e) => {
                    pickupTimeRef.current = e;
                    handleUpdateSearchState(
                      'onwordDetails.journeyTime',
                      getTime24Hour(e),
                    );
                  }}
                />
                <small className="validation-error">{errors.journeyTime}</small>
              </Col>
              <Col lg={2} md={2} sm={12} xs={12}>
                <div
                  className="modify-travellers-class d-flex justify-content-between align-items-center cursor-pointer"
                  ref={passengersOverlayTarget}
                  onClick={() => setOpenPassengers(!openPassengers)}
                >
                  <div className="d-flex flex-column">
                    <span className="fs-12 travellers-class_label">
                      <FormattedMessage id="travellers" />,{' '}
                      <FormattedMessage id="class" />
                    </span>
                    <span className="travellers-class_text">
                      {parseInt(search.adults, 10)}A,
                      {search.childs > 0 && `${parseInt(search.childs, 10)}C,`}
                      {search.infants > 0 &&
                        `${parseInt(search.infants, 10)}I,`}
                    </span>
                  </div>
                  {openPassengers ? (
                    <MdKeyboardArrowUp />
                  ) : (
                    <MdKeyboardArrowDown />
                  )}
                </div>
                <Overlay
                  rootClose
                  target={passengersOverlayTarget.current}
                  show={openPassengers}
                  placement="bottom"
                  onHide={() => setOpenPassengers(false)}
                >
                  {({
                    placement,
                    arrowProps,
                    show: _show,
                    popper,
                    ...props
                  }) => (
                    <div
                      {...props}
                      style={{
                        position: 'absolute',
                        padding: '1rem',
                        borderRadius: '8px',
                        maxWidth: isMobileView.current ? '92%' : '320px',
                        backgroundColor: '#b0d3f6',
                        zIndex: 9999,
                        ...props.style,
                      }}
                      className="travellers-class_overlay"
                    >
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="adults12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map(
                              (pax) =>
                                pax !== '0' && (
                                  <li
                                    key={pax}
                                    className={`${
                                      search.adults === pax ? 'selected' : ''
                                    } num-pax_list_item`}
                                    onClick={() =>
                                      handleUpdateSearchState('adults', pax)
                                    }
                                  >
                                    {pax}
                                  </li>
                                ),
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="children_2_12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.childs === pax ? 'selected' : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('childs', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="d-flex gap-3 flex-wrap">
                          {search.childs > 0 &&
                            Array.from({
                              length: parseInt(search.childs, 10),
                            }).map((_, indexOfChild) => (
                              <div key={indexOfChild}>
                                <div className="my-1 d-flex gap-1 fs-12 flex-column align-items-center">
                                  <label
                                    htmlFor={`child${indexOfChild}`}
                                    className="fw-500"
                                  >
                                    {formattedMessage('child')}{' '}
                                    {indexOfChild + 1} {formattedMessage('age')}
                                    *
                                  </label>
                                  <select
                                    name={`child${indexOfChild}`}
                                    value={search.childAges[indexOfChild]}
                                    onChange={(e) =>
                                      handleChildAgeChange(
                                        indexOfChild,
                                        e.target.value,
                                      )
                                    }
                                    style={{
                                      width: 'fit-content',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                  </select>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="infant_2" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.infants === pax ? 'selected' : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('infants', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="text-center">
                        <AppButton
                          btnText={<FormattedMessage id="done_btn" />}
                          onClick={() => setOpenPassengers(false)}
                          variant="secondary"
                          className="px-4"
                        />
                      </div>
                    </div>
                  )}
                </Overlay>
              </Col>
              <Col lg={2} md={2} sm={12} xs={12}>
                <AppButton
                  btnText="Search Cabs"
                  variant="primary"
                  onClick={handleCabSearch}
                  className="w-100"
                />
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
}
CabsSearch.defaultProps = {
  cab: false,
};
CabsSearch.propTypes = {
  cab: PropTypes.bool,
};
export default CabsSearch;
